var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"theme-dark transition",class:this.getTheme,attrs:{"id":"app"}},[_c('router-view',{staticClass:" w-screen h-screen"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }